<template>
    <div clas="aup__dev-nav">
        <div class="aup__dev-nav__sony row align-items-center m-0 px-3">
            <div class="col d-flex align-items-center">
                <img :src="sonyLogo"/>
            </div>
        </div>
        <div class="aup__dev-nav__au row align-items-center m-0 px-3">
            <div class="col d-flex align-items-center">
                <img :src="auLogo"/>
            </div>
			<div
				v-for="route in routes"
				:key="route.path"
				class="col d-flex align-items-center justify-content-end"
			>
				<router-link
					class=" font font--white mr-3"
					:to="route"
					exact-active-class="font--semibold"
					exact
				>
					
				</router-link>

			</div>
        </div>
    </div>
</template>

<script>
import auLogo from "@/components/dev/au-logo-screenshot.png";
import sonyLogo from "@/components/dev/sony-logo-screenshot.png";
export default {
	name: 'Menu',
	computed: {
		routes: function() {
			let routes = [];
			for (let i in this.$router.options.routes) {
				if (!this.$router.options.routes.hasOwnProperty(i)) {
					continue;
				}
				let route = this.$router.options.routes[i];
				if (route.hasOwnProperty('name')) {
					routes.push(route);
				}
			}
			return routes;
		},
	},
    data() {
        return {
            auLogo,
            sonyLogo
        }
    }
}
</script>

<style lang="scss">
  .aup__dev-nav {
        background-color: black;

      &__sony {
        max-width: 100vw;
        height: 45px;
        background-color: black;
      }

      &__au {
        max-width: 100vw;
        background-color: black;
        height: 80px;
        position: -webkit-sticky; /* Safari */
        position: sticky;
        top: 0;
      }
  }
</style>
